import { X, Copy, Loader2 } from "lucide-react";

export function ModalShell({ testid, zIndex, borderClass, onClose, closeTestid, children }) {
  return (
    <div
      className={`fixed inset-0 ${zIndex} bg-black/80 backdrop-blur-md grid place-items-center p-6`}
      onClick={onClose}
      data-testid={testid}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className={`relative w-full max-w-lg bl-glass border ${borderClass} p-8 md:p-10`}
        style={{ background: "linear-gradient(160deg, rgba(10,14,26,0.98), rgba(0,0,0,0.98))" }}
      >
        <button
          onClick={onClose}
          data-testid={closeTestid}
          className="absolute top-4 right-4 text-white/40 hover:text-white transition-colors"
          aria-label="Close"
        >
          <X size={18} />
        </button>
        {children}
      </div>
    </div>
  );
}

export function PromoCodeBox({ result, onCopy, testid, caption }) {
  return (
    <div
      onClick={onCopy}
      className="mt-6 border border-[color:var(--bl-gold)]/40 bg-[color:var(--bl-gold)]/5 py-5 px-6 flex items-center justify-between gap-4 cursor-pointer hover:bg-[color:var(--bl-gold)]/10 transition-colors group"
      data-testid={testid}
    >
      <div>
        <div className="font-display text-white text-3xl tracking-widest">{result.promo_code}</div>
        <div className="font-mono text-[11px] tracking-[0.22em] uppercase text-[color:var(--bl-gold)] mt-1">
          {result.percent}% off {caption}
        </div>
      </div>
      <Copy size={16} className="text-white/50 group-hover:text-white transition-colors" />
    </div>
  );
}

export function EmailCaptureForm({ email, setEmail, submitting, onSubmit, onSkip, prefix, submitLabel, skipLabel, buttonClass }) {
  return (
    <form onSubmit={onSubmit} className="mt-6 space-y-3">
      <input
        type="email"
        required
        autoFocus
        data-testid={`${prefix}-email`}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="you@domain.com"
        className="w-full bg-transparent border border-white/15 focus:border-[color:var(--bl-blue)] outline-none px-4 py-3.5 text-white font-mono text-sm"
      />
      <button
        type="submit"
        disabled={submitting}
        data-testid={`${prefix}-submit`}
        className={`w-full bl-btn ${buttonClass} inline-flex items-center justify-center gap-2 py-3.5`}
      >
        {submitting ? <Loader2 size={14} className="animate-spin" /> : submitLabel}
      </button>
      <button
        type="button"
        onClick={onSkip}
        data-testid={`${prefix}-skip`}
        className="w-full text-white/40 hover:text-white/70 font-mono text-[10px] tracking-[0.25em] uppercase py-2"
      >
        {skipLabel}
      </button>
    </form>
  );
}
